import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5b873166"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-container" }
const _hoisted_2 = { class: "p-mx-2" }
const _hoisted_3 = { class: "p-mx-2" }
const _hoisted_4 = { class: "p-mx-2" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", { class: "p-text-center top-bar" }, [
  /*#__PURE__*/_createElementVNode("i", {
    style: {"font-size":"1rem"},
    class: "pi pi-check-circle"
  }),
  /*#__PURE__*/_createTextVNode(" Manage Permissions "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("small", null, "Please logout and login to apply new privileges")
], -1))
const _hoisted_6 = {
  key: 0,
  class: "role-info-panel"
}
const _hoisted_7 = { class: "p-grid p-align-center" }
const _hoisted_8 = { class: "p-col-12" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Role Type:", -1))
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = {
  key: 0,
  class: "p-col-12 p-mt-2"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Assigned to Pharmacies:", -1))
const _hoisted_14 = { class: "p-mt-1" }
const _hoisted_15 = { class: "group-header" }
const _hoisted_16 = { class: "p-grid p-px-2" }
const _hoisted_17 = {
  key: 0,
  class: "p-field-checkbox"
}
const _hoisted_18 = ["for"]
const _hoisted_19 = {
  key: 1,
  class: "p-field-checkbox"
}
const _hoisted_20 = ["for"]
const _hoisted_21 = { class: "p-field" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "roleName" }, "Role Name *", -1))
const _hoisted_23 = {
  key: 0,
  class: "p-error"
}
const _hoisted_24 = { class: "p-field" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "levelId" }, "Level *", -1))
const _hoisted_26 = {
  key: 0,
  class: "p-error"
}
const _hoisted_27 = {
  key: 0,
  class: "p-field"
}
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "pharmacyIds" }, "Pharmacies *", -1))
const _hoisted_29 = {
  key: 0,
  class: "p-error"
}
const _hoisted_30 = {
  key: 1,
  class: "p-field"
}
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", { class: "p-text-secondary" }, " This role will be created for your current pharmacy. ", -1))
const _hoisted_32 = [
  _hoisted_31
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Toolbar = _resolveComponent("Toolbar")!
  const _component_MultiSelect = _resolveComponent("MultiSelect")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_Toolbar, null, {
        start: _withCtx(() => [
          _createVNode(_component_Breadcrumb, {
            home: _ctx.home,
            model: _ctx.items,
            class: "p-menuitem-text"
          }, null, 8, ["home", "model"])
        ]),
        end: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            false
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  icon: "pi pi-plus",
                  class: "p-button-primary",
                  onClick: _ctx.openCreateRoleDialog,
                  label: "Create Role"
                }, null, 8, ["onClick"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Dropdown, {
              style: {"width":"15rem"},
              modelValue: _ctx.selectedRoleID,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedRoleID) = $event)),
              options: _ctx.roles,
              optionLabel: "name",
              optionValue: "id",
              onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loadList()))
            }, null, 8, ["modelValue", "options"])
          ]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_Button, {
              icon: "pi pi-save",
              class: "p-button-success",
              onClick: _ctx.savePermissions,
              label: "Save",
              disabled: _ctx.selectedRoleID == 0
            }, null, 8, ["onClick", "disabled"])
          ])
        ]),
        _: 1
      }),
      _hoisted_5,
      (_ctx.selectedRoleID != 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                (_ctx.rolePharmacyIds.length === 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_10, "Global Role"))
                  : (_openBlock(), _createElementBlock("span", _hoisted_11, "Pharmacy-Specific Role"))
              ]),
              (_ctx.rolePharmacyIds && _ctx.rolePharmacyIds.length > 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _hoisted_13,
                    _createElementVNode("div", _hoisted_14, [
                      (_ctx.pharmacyList && _ctx.pharmacyList.length > 0)
                        ? (_openBlock(), _createBlock(_component_MultiSelect, {
                            key: 0,
                            modelValue: _ctx.editablePharmacyIds,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.editablePharmacyIds) = $event)),
                            options: _ctx.pharmacyList,
                            optionLabel: "name",
                            optionValue: "id",
                            placeholder: "Select Pharmacies",
                            display: "chip",
                            style: {"width":"100%","max-width":"600px"}
                          }, null, 8, ["modelValue", "options"]))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.groupedPermissions, (group, typeId) => {
          return (_openBlock(), _createElementBlock("div", { key: typeId }, [
            _createElementVNode("h5", _hoisted_15, _toDisplayString(group.type), 1),
            _createElementVNode("div", _hoisted_16, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.items, (p) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "p-col-3",
                  key: p.id
                }, [
                  ((p.level_id > _ctx.getRole().level_id || this.getRole().level_id == _ctx.RoleLevels.SUPER_ADMIN))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                        _createVNode(_component_Checkbox, {
                          id: p.id,
                          modelValue: _ctx.checkedPermission,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.checkedPermission) = $event)),
                          value: p.id
                        }, null, 8, ["id", "modelValue", "value"]),
                        _createElementVNode("label", {
                          for: p.id
                        }, _toDisplayString(p.title), 9, _hoisted_18)
                      ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_19, [
                        _createElementVNode("label", {
                          for: p.id
                        }, _toDisplayString(p.title) + " (Restricted)", 9, _hoisted_20)
                      ]))
                ]))
              }), 128))
            ])
          ]))
        }), 128))
      ])
    ]),
    _createVNode(_component_Dialog, {
      visible: _ctx.createRoleDialog,
      "onUpdate:visible": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.createRoleDialog) = $event)),
      style: { width: '450px' },
      header: "Create New Role",
      modal: true,
      class: "p-fluid"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_Button, {
          label: "Cancel",
          icon: "pi pi-times",
          class: "p-button-text",
          onClick: _ctx.hideCreateRoleDialog
        }, null, 8, ["onClick"]),
        _createVNode(_component_Button, {
          label: "Create",
          icon: "pi pi-check",
          class: "p-button-primary",
          onClick: _ctx.createRole
        }, null, 8, ["onClick"])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          _createVNode(_component_InputText, {
            id: "roleName",
            modelValue: _ctx.newRole.name,
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newRole.name) = $event)),
            required: "true",
            autofocus: "",
            class: _normalizeClass({ 'p-invalid': _ctx.submitted && !_ctx.newRole.name })
          }, null, 8, ["modelValue", "class"]),
          (_ctx.submitted && !_ctx.newRole.name)
            ? (_openBlock(), _createElementBlock("small", _hoisted_23, " Role name is required. "))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createVNode(_component_Dropdown, {
            id: "levelId",
            modelValue: _ctx.newRole.level_id,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newRole.level_id) = $event)),
            options: _ctx.levelOptions,
            optionLabel: "label",
            optionValue: "value",
            placeholder: "Select Level",
            class: _normalizeClass({ 'p-invalid': _ctx.submitted && !_ctx.newRole.level_id })
          }, null, 8, ["modelValue", "options", "class"]),
          (_ctx.submitted && !_ctx.newRole.level_id)
            ? (_openBlock(), _createElementBlock("small", _hoisted_26, " Level is required. "))
            : _createCommentVNode("", true)
        ]),
        (_ctx.pharmacyList.length > 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _hoisted_28,
              _createVNode(_component_MultiSelect, {
                id: "pharmacyIds",
                modelValue: _ctx.newRole.pharmacy_ids,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newRole.pharmacy_ids) = $event)),
                options: _ctx.pharmacyList,
                optionLabel: "name",
                optionValue: "id",
                placeholder: "Select Pharmacies",
                display: "chip",
                class: _normalizeClass({ 'p-invalid': _ctx.submitted && (!_ctx.newRole.pharmacy_ids || _ctx.newRole.pharmacy_ids.length === 0) })
              }, null, 8, ["modelValue", "options", "class"]),
              (_ctx.submitted && (!_ctx.newRole.pharmacy_ids || _ctx.newRole.pharmacy_ids.length === 0))
                ? (_openBlock(), _createElementBlock("small", _hoisted_29, " At least one pharmacy is required. "))
                : _createCommentVNode("", true)
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_30, _hoisted_32))
      ]),
      _: 1
    }, 8, ["visible"])
  ]))
}